import { createAction, props } from '@ngrx/store';
import { MyUserReport } from 'app/interfaces';

export const loadMyReportsList = createAction(
  '[MyReportsList] Load My Reports List',
  props<{ projectId: number }>()
);

export const loadMyReportsListSuccess = createAction(
  '[MyReportsList] Load My Reports List Success',
  props<{ projectId: number; reports: any[] }>()
);

export const loadMyReportsListError = createAction(
  '[MyReportsList] Load My Reports List Error',
  props<{ projectId: number; payload: any }>()
);

export const addMyReport = createAction(
  '[MyReportsList] Add My Report',
  props<{ projectId: number; report: MyUserReport }>()
);

export const addMyReportSuccess = createAction(
  '[MyReportsList] Add My Report Success',
  props<{ report: any }>()
);

export const addMyReportError = createAction(
  '[MyReportsList] Add My Report Error',
  props<{ payload: any }>()
);

export const selectMyReport = createAction(
  '[MyReportsList] Select My Report',
  props<{ report: any }>()
);

export const deleteMyReport = createAction(
  '[MyReportsList] Delete My Report',
  props<{ projectId: number; reportId: number }>()
);

export const deleteMyReportSuccess = createAction(
  '[MyReportsList] Delete My Report Success',
  props<{ reportId: number }>()
);

export const deleteMyReportError = createAction(
  '[MyReportsList] Delete My Report Error',
  props<{ payload: any }>()
);

export const updateMyReport = createAction(
  '[MyReportsList] Update My Report',
  props<{ projectId: number; reportId: number; report: MyUserReport }>()
);

export const updateMyReportSuccess = createAction(
  '[MyReportsList] Update My Report Success',
  props<{ report: any }>()
);

export const updateMyReportError = createAction(
  '[MyReportsList] Update My Report Error',
  props<{ payload: any }>()
);

export const resetMyReportsList = createAction(
  '[MyReportsList] resetMyReportsList',
  props<{ onReset: boolean }>()
);
